import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import { Page, Heading, Link, Container, CircleImage } from '../..';
import { BRAND } from '../../../constants/brand';

import styles from './Faq.module.scss';
import { BOOKING_LINK } from '../../../constants/booking';

interface FaqProps {
  className?: string;
  location?: object;
}

const Faq: FunctionComponent<FaqProps> = ({ className, location }) => {
  const faqClass = classNames(`${BRAND.SUPER_SHORT_NAME}-faq`, className, {
    [styles.faq]: true,
  });

  return (
    <Page className={faqClass} location={location}>
      <section className={styles.faqSection}>
        <Heading level={1}>Frequently Asked Questions</Heading>
        <div className={styles.row}>
          <div className={styles.leftCol}>
            <Container>
              <CircleImage className={styles.circles} images={['4', '6']} />
            </Container>
          </div>
          <div className={styles.rightCol}>
            <Container>
              <p>
                We want to be honest with you, 100% transparency when it comes
                to our treatments. Below are some questions we get asked
                regularly, but if you feel we didn’t answer yours, send us a
                message and we will get back to you!
              </p>
              <Heading level={2}>How does it work?</Heading>
              <p>
                The process is the same as braces, we clean the tooth, protect
                the enamel and then using adhesive, we apply the crystal or gold
                piece of your choice.
              </p>
              <Heading level={2}>Does it hurt?</Heading>
              <p>
                No way josè! There are no drills, no holes, no pain & no
                problem!
              </p>
              <Heading level={2}>Is it super glued on?</Heading>
              <p>
                HELL NO! Sure back in the 90’s you might go to your local nail
                shop and they would apply a cheap crystal with nail glue, but
                not us! There is no super glue, nail glue, no more nails or
                gorilla glue in sight! The adhesive used is dental grade, the
                same used to put your train track braces on, it completely safe!
              </p>
            </Container>
          </div>
        </div>
        <Container>
          <Heading level={2}>How long does it last?</Heading>
          <p>
            As long as you want it to! We use the top quality dental grade
            products on the market that have been tried and tested to ensure
            longevity. We like to recommend anywhere from 1 month to 2 years
            (however we find them last much longer than that) as long as you’re
            looking after your new shiny baby!
          </p>
          <Heading level={2}>Is it reversible?</Heading>
          <p>
            Totally, we understand you like to change up your style; the same
            way you might change your hair or piercings, Crystal Canine is
            completely reversible with ZERO damage. Simply go to your local
            dentist or hygienist for safe removal.
          </p>
          <Heading level={2}>
            I wear a retainer, I have veneers, can I still get it?
          </Heading>
          <p>
            Unfortunately tooth gems won’t stay very long term on veneer’s or
            false teeth, if for example you have veneer’s on your front teeth,
            but not the others, we can apply onto your natural teeth, If you
            wear a retainer, please bring it to your appointment so we can place
            the tooth gem around it. It’s no problem at all!
          </p>
          <Heading level={2}>What products are used?</Heading>
          <p>
            At Crystal Canine, we care about your teeth and just wanna enhance
            your smile! We use the best dental products on the market, genuine
            lead free Swarovski crystals, 22k gold, white gold and .1 CT
            diamonds!
          </p>
          <Heading level={2}>
            What if I lose my tooth gem, will I swallow it?
          </Heading>
          <p>
            In all honesty, maybe! But don’t stress, all the products we use are
            totally safe to be in your mouth, if you lose a gem, it’ll just come
            out the other side, if you have any product left on your tooth, you
            can have this removed super easily and quickly at your local dentist
            or hygienist.
          </p>
          <Heading level={2}>I’m not sure what I want?! </Heading>
          <p>
            Don’t sweat, we got you, come see us to see our selection of gold
            &amp; white gold and look at our crystal menu and displays in
            person! Photos honestly don’t do our wide selection justice.
          </p>
          <Heading level={2}>What gold pieces do you have in stock?</Heading>
          <p>
            We usually have a wide range of our gold pieces, however, these go
            quickly. If you want something specific, send us a message and it
            can be ordered in just for you. We can do everything from old
            English letters, star signs, brand logos and more.
          </p>
          <Heading level={2}>Are you a dentist?</Heading>
          <p>
            I’m not, I’m only qualified to apply your tooth gems. I won’t remove
            them and can’t help if you have a tooth ache!
          </p>
        </Container>
      </section>
      <section className={styles.booking}>
        <Container>
          <Heading level={3}>Booking Enquiries</Heading>
          <p>
            With over 150 options of crystals, gold, &amp; diamonds, you can get
            something uniquely you! From loud and proud to subtle shine, as well
            as everything in between. We will get your smile looking real cute,
            real soon! Wanna feel inspired? Have a look at our virtual crystal
            menu to see just some of the possibilities.
          </p>
          <Link
            external
            to={BOOKING_LINK}
            label="Clicking this link will take you through to our external booking system."
          >
            Booking Enquiries
          </Link>
        </Container>
      </section>
    </Page>
  );
};

export default Faq;
